var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"id":"path-1","points":"14.625 9.125 14.625 17.125 10.375 13.1647995","fill":"currentColor"}));
}

ArrowDown.defaultProps = {"width":"25px","height":"25px","viewBox":"0 0 25 25","version":"1.1"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
